import { useEffect, useState } from 'react'
import ReservationSidebar from '../Commun/ReservationSidebar'
import ReservationHeader from '../Commun/ReservationHeader'
import { GetResCorporatedetail, Property } from '../../Services/Service';
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { fetchCompanyReport } from '../../Redux/Slices/reservationCompanyReportSlice';
import * as XLSX from "xlsx";

export const CompanyReport = () => {

    const dispatch = useDispatch();
    const [propertyList, setPropertyList] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState("");
    const [checkIn, setCheckIn] = useState("");
    const [checkOut, setCheckOut] = useState("");
    const [bookingFrom, setBookingFrom] = useState("");
    const [bookingTo, setBookingTo] = useState("");
    const [CorporateList, steCorporateList] = useState([]);
    const [selectedCorporate, setSelectedCorporate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [exportLoadingBusiness, setExportLoadingBusiness] = useState(false);

    const { data } = useSelector((state) => state.companyProduReport);

    useEffect(() => {
        fetchProperty();
    }, []);

    const fetchProperty = async () => {
        const data = await Property();
        setPropertyList(data);

        setSelectedProperty("");
    };


    // Convert API data for react-select
    const propertyOptions = propertyList?.map((item) => ({
        value: item.PropertyID,
        label: item.PropertyName,
    }));

    const handlePropertyChange = (selectedOptions) => {
        setSelectedProperty(selectedOptions);
    };

    useEffect(() => {
        const GetCorporatedetails = async () => {
            setLoading(true);
            try {
                const result = await GetResCorporatedetail(selectedProperty?.value);
                // console.log("corporate data", result)
                if (Array.isArray(result)) {
                    steCorporateList(result);
                }
            }
            catch (error) {
                console.log("error getting corporate detail", error);
            } finally {
                setLoading(false);
            }
        }
        GetCorporatedetails();
    }, [selectedProperty]);


    // ✅ FILTER BUTTON
    useEffect(() => {
        if (!selectedProperty) return;

        const params = {
            PID: selectedProperty?.value ? `[${selectedProperty.value}]` : "[]",
            CheckInDate: checkIn,
            CheckOutDate: checkOut,
            BookingFrom: bookingFrom,
            BookingTo: bookingTo,
            CompanyName: selectedCorporate?.value || "",
        };

        dispatch(fetchCompanyReport(params));

    }, [selectedProperty, checkIn, checkOut, bookingFrom, bookingTo, selectedCorporate, dispatch]);

    // ✅ CLEAR BUTTON
    const handleClear = () => {
        setSelectedProperty("");
        setCheckIn("");
        setCheckOut("");
        setBookingFrom("");
        setBookingTo("");
        setSelectedCorporate(null);

        // API call without filters
        const params = {
            PID: "",
            CheckInDate: "",
            CheckOutDate: "",
            BookingFrom: "",
            BookingTo: "",
            CompanyName: "",
        };

        dispatch(fetchCompanyReport(params));
    };

     const exportBusinessSourceToExcel = () => {
            if (!data || data.length === 0) return;
    
            try {
                setExportLoadingBusiness(true);
    
                const formattedData = data.map((item, index) => ({
                    "Sr#": index + 1,
                    "Company Name": item.Reg_CompName,
                    "OCC": item.OCC,
                    "PAX": item.PAX,
                    "Revenue": item.Revenue,
                    "ARR": item.ARR
                }));
    
                const worksheet = XLSX.utils.json_to_sheet(formattedData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Business Source Report");
    
                const excelBuffer = XLSX.write(workbook, {
                    bookType: "xlsx",
                    type: "array"
                });
    
                const blob = new Blob([excelBuffer], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
                });
    
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "Company_Productivity_Report.xlsx";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
    
            } catch (error) {
                console.error("Company Productivity Export Error:", error);
            } finally {
                setExportLoadingBusiness(false);
            }
        };


    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}

             {exportLoadingBusiness && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}

            <div className="wrapper">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />

                    <div className="container">
                        <div className="page-inner">

                            <form>
                                <div className='row mb-3'>
                                    <div className='col-md-12'>
                                        <label className='form-label'>Company Productivity</label>
                                        <Select
                                            options={propertyOptions}
                                            value={selectedProperty}
                                            onChange={handlePropertyChange}
                                            placeholder="Select Property"
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                        />
                                    </div>
                                </div>
                                <div className='row mb-3'>
                                    <div className='col-md-2'>
                                        <label className='form-label'>Check In</label>
                                        <input
                                            type='date'
                                            className='form-control'
                                            value={checkIn}
                                            onChange={(e) => setCheckIn(e.target.value)}
                                        />
                                    </div>

                                    <div className='col-md-2'>
                                        <label className='form-label'>Check Out</label>
                                        <input
                                            type='date'
                                            className='form-control'
                                            value={checkOut}
                                            onChange={(e) => setCheckOut(e.target.value)}
                                        />
                                    </div>

                                    <div className='col-md-2'>
                                        <label className='form-label'>Booking From</label>
                                        <input
                                            type='date'
                                            className='form-control'
                                            value={bookingFrom}
                                            onChange={(e) => setBookingFrom(e.target.value)}
                                        />
                                    </div>

                                    <div className='col-md-2'>
                                        <label className='form-label'>Booking To</label>
                                        <input
                                            type='date'
                                            className='form-control'
                                            value={bookingTo}
                                            onChange={(e) => setBookingTo(e.target.value)}
                                        />
                                    </div>

                                    <div className='col-md-3'>
                                        <label className='form-label'>Company</label>
                                        <Select
                                            options={(CorporateList || []).map((item) => ({
                                                value: item.TA_Name,
                                                label: item.TA_Name
                                            })) || []}
                                            value={selectedCorporate}
                                            onChange={(selectedOption) => setSelectedCorporate(selectedOption)}
                                            placeholder="Select Company"
                                            isClearable={true}
                                        />
                                    </div>

                                    <div className='col-md-1 d-flex align-items-end'>

                                        <button
                                            type="button"
                                            onClick={handleClear}
                                            className='btn btn-danger'
                                        >
                                            Clear
                                        </button>
                                    </div>
                                </div>
                            </form>

                            <div className="row">
                                <div className="col-md-12">

                                    <div className="card">
                                        <div className="card-header">
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h4 className="card-title">Company Productivity Report</h4>
                                                <button className='btn btn-sm btn-primary' type="button" onClick={exportBusinessSourceToExcel}>Export</button>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">

                                                <DataTable
                                                    value={data}
                                                    // paginator

                                                    rows={10}
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                    showGridlines
                                                    stripedRows
                                                    responsiveLayout="scroll"
                                                    className="p-datatable-bordered"
                                                    filterDisplay="row"   // 🔥 header ke niche filter box
                                                    emptyMessage="No records found"
                                                >
                                                    <Column
                                                        field="Reg_CompName"
                                                        header="Company Name"
                                                        sortable
                                                        filter
                                                        filterPlaceholder="Search"
                                                    />

                                                    <Column
                                                        field="OCC"
                                                        header="OCC"
                                                        sortable
                                                        filter
                                                        filterPlaceholder="Search"
                                                    />

                                                    <Column
                                                        field="PAX"
                                                        header="PAX"
                                                        sortable
                                                        filter
                                                        filterPlaceholder="Search"
                                                    />

                                                    <Column
                                                        field="Revenue"
                                                        header="Revenue"
                                                        sortable
                                                        filter
                                                        filterPlaceholder="Search"
                                                    />

                                                    <Column
                                                        field="ARR"
                                                        header="ARR"
                                                        sortable
                                                        filter
                                                        filterPlaceholder="Search"
                                                    />
                                                </DataTable>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                </div>
            </div>
        </>
    )
}
